<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-row>
        <b-col md="6" sm="12">
            <b-card border-variant="secondary"
                header="DETALLES"
                header-border-variant="secondary">
            <b-row>
                <b-col md="12">
                    <b-button v-if="!declaracion.conclusion"
                        @click="concluirDeclaracion()"
                        class="pull-right"
                        size="sm"
                        variant="primary">Concluir declaración</b-button>
                        <br><br>
                </b-col>
                <b-col md="12">
                    <!-- <b-button v-if="!declaracion.conclusion" size="sm" variant="secondary"><i  class="fa fa-pencil" @click="modificaTipo()"></i></b-button> -->
                    <b> Tipo declaración:</b> {{ declaracion.tipo}}
                </b-col>
                <b-col md="12">
                    <p><b>Estado de la declaración:</b> {{ declaracion.status}} </p>
                    <p v-if="declaracion.conclusion"><b>Fecha de conclusión:</b> {{ conclusion }} </p>
                    <p v-if="declaracion.conclusion"><b>Fecha de recepción:</b> {{ recepcion}} </p>
                </b-col>
                <b-col md="12">
                    <b-button v-if="declaracion.conclusion"
                        @click="imprimeRecibo()"
                        variant="secondary"
                        size="sm"> Formato de entrega
                    </b-button>
                    <!-- <b-button
                        v-if="declaracion.conclusion"
                        @click="imprimeDeclaracion()"
                        variant="primary"
                        size="sm"
                        class="pull-right">Imprimir declaración
                    </b-button> -->
                </b-col>
            </b-row>
            </b-card>
             <b-list-group>
          <b-list-group-item  @click="verSeccion(1)" href="#" class="flex-column align-items-start">
            <p class="mb-1">1. Datos generales</p>
          </b-list-group-item>
          <b-list-group-item  @click="verSeccion(2)" href="#" class="flex-column align-items-start" >
            <p class="mb-1">2. Domicilio del declarante</p>
          </b-list-group-item>
          <b-list-group-item  @click="verSeccion(3)" href="#" class="flex-column align-items-start">
            <p class="mb-1">3. Datos curriculares del declarante</p>
          </b-list-group-item>
          <b-list-group-item  @click="verSeccion(4)" href="#" class="flex-column align-items-start">
            <p class="mb-1">4. Datos del empleo, cargo o comisión</p>
          </b-list-group-item>
          <b-list-group-item  @click="verSeccion(5)" href="#" class="flex-column align-items-start">
            <p class="mb-1">5. Experiencia laboral</p>
          </b-list-group-item>
          <b-list-group-item @click="verSeccion(6)" href="#" class="flex-column align-items-start">
            <p class="mb-1">6. Datos de la pareja</p>
          </b-list-group-item>
          <b-list-group-item  @click="verSeccion(7)" href="#" class="flex-column align-items-start">
            <p class="mb-1">7. Datos del dependiente económico</p>
          </b-list-group-item>
          <b-list-group-item @click="verSeccion(8)" href="#" class="flex-column align-items-start">
            <p v-if="declaracion.tipo == 'INICIAL'"  class="mb-1">8. Ingresos netos del declarante, pareja y/o dependientes económicos (Situación actual)</p>
            <p v-if="declaracion.tipo == 'CONCLUSION'"  class="mb-1">8. Ingresos netos del año en curso a la fecha de conclusión del empleo, cargo o comisión del declarante, pareja y/o dependientes económicos</p>
            <p v-if="declaracion.tipo == 'MODIFICACION'"  class="mb-1">8. Ingresos netos del declarante, pareja y/o dependientes económicos (Entre 1 de Enero y 31 de diciembre del año anterior)</p>
          </b-list-group-item>

          <b-list-group-item  v-if="declaracion.tipo !== 'MODIFICACION'" @click="verSeccion(8.5)" href="#" class="flex-column align-items-start">
            <p class="mb-1">8.5 Acitividad anual anterior</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(9)" href="#" class="flex-column align-items-start">
            <p  class="mb-1" >9. Bienes inmuebles del declarante, cónyuge, concubina o concubinario y/o dependientes económicos</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(10)" href="#" class="flex-column align-items-start">
            <p class="mb-1">10. Vehículos automotores, aeronaves y embarcaciones del declarante, cónyuge, concubina o concubinario y/o dependientes económicos</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(11)" href="#" class="flex-column align-items-start">
            <p class="mb-1">11. Bienes muebles</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(12)" href="#" class="flex-column align-items-start">
            <p class="mb-1">12. Inversiones, cuentas bancarias y otro tipo de valores</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(13)" href="#" class="flex-column align-items-start">
            <p class="mb-1">13. Adeudos del declarante, cónyuge, concubina o concubinario y/o dependientes económicos</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(14)" href="#" class="flex-column align-items-start">
            <p class="mb-1">14. Participaciones</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(15)" href="#" class="flex-column align-items-start">
            <p class="mb-1">15. Participación, toma de desiciones</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(16)" href="#" class="flex-column align-items-start">
            <p class="mb-1">16. Prestamos</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(17)" href="#" class="flex-column align-items-start">
            <p class="mb-1">17. Apoyos</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(18)" href="#" class="flex-column align-items-start">
            <p class="mb-1">18. Representaciones</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(19)" href="#" class="flex-column align-items-start">
            <p class="mb-1">19. Clientes Principales</p>
          </b-list-group-item>
          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(20)" href="#" class="flex-column align-items-start">
            <p class="mb-1">20. Beneficios Privados</p>
          </b-list-group-item>

          <b-list-group-item v-if="declaracionCorta" @click="verSeccion(21)" href="#" class="flex-column align-items-start">
            <p class="mb-1">21. Fideicomisos</p>
          </b-list-group-item>
        </b-list-group>
            <br>
            <b-button size="sm" variant="secondary" @click="regresar">Regresar </b-button>

        </b-col>
        <b-col md="6" sm="12">

            <b-jumbotron lead="Aviso de privacidad">
                <p class="text-justify"><b>Los datos personales recabados serán protegidos y tratados en el Sistema de Declaración del Municipio de El Salto, Jalisco, cuya finalidad es que los servidores públicos, a través de medios remotos de comunicación y utilizando la firma electrónica avanza o Registro Federal de y contraseña de acceso al sistema, cumplan con su obligación de declarar su situación patrimonial y de intereses, para que la Contraloría Ciudadana, en ejercicio de sus atribuciones pueda analizar la evolución de su patrimonio, y los datos contenidos en el referido sistema, así como realizar la transmisión de éstos al Ministerio Publico, los Tribunales o las autoridades judiciales, en el ejercicio de sus respectivas atribuciones, al servidor público interesado o bien, cuando las Autoridades Investigadoras, substanciadoras o resolutoras lo requieran con motivo de la investigación o la resolución de procedimientos de responsabilidades administrativas</b></p>
                <p class="text-justify">Con fundamento en lo dispuesto por el último párrafo del artículo 108 de la Constitución Política de los Estados Unidos Mexicanos, así como por los artículos 1, 2, fracción I, 4, fracción I, 9, 29, 32, 33, 34, 35, 46 primer párrafo, 47 y 48 de la Ley General de Responsabilidades Administrativas, publicada en el Diario Oficial de la Federación el 18 de julio de 2016, así como de su artículo Transitorio TERCERO que establece que hasta en tanto el Comité  Coordinador del Sistema Nacional Anticorrupción determina los formatos para la presentación de las declaraciones patrimonial y de intereses, los servidores públicos de todos los órdenes de gobierno presentarán sus declaraciones en los formatos que a la entrada en vigor de la Ley General de Responsabilidades Administrativas, se utilicen en el ámbito Federal; en concordancia con el “Acuerdo por el que el Comité Coordinador del Sistema Nacional Anticorrupción da a conocer la obligación de presentar las declaraciones de situación patrimonial y de intereses conforme a los artículos 32 y 33 de la Ley General de Responsabilidades Administrativas”, publicado en el Diario Oficial de la Federación el 14 de julio de 2017.</p>
            </b-jumbotron>
        </b-col>
    </b-row>
  </div>
</template>

<script>

import axios from 'axios'
import swal from 'sweetalert2'
import Loader from '../../../../src/views/Loader'
import { mapGetters } from "vuex";

const date = require('date-and-time');
date.locale('es');

const jsPDF = require('jspdf');
const base64Img = require('base64-img');

export default {
  name: "indice",
  components: { Loader },
  props: ['declaracion','generales', 'puesto'],
  computed:{
      ...mapGetters(["httpURL","sessionToken","logoHorizontal"]),
      conclusion(){
          if(this.declaracion.conclusion){
              let fecha = new Date(this.declaracion.conclusion);
              return date.format(fecha,'D de MMMM de YYYY')
          }else
            return null;
      },
      recepcion(){
          if(this.declaracion.recepcion){
              let fecha = new Date(this.declaracion.recepcion);
              return date.format(fecha,'D de MMMM de YYYY')
          }else
            return 'No recibida';
      },
      tipoDec(){
            if( this.declaracion.tipo === 'INICIAL')
                return 'inicia'
            if( this.declaracion.tipo === 'MODIFICACIÓN')
                return 'modifica'
            if( this.declaracion.tipo === 'CONCLUSIÓN')
            return 'concluye'
      },
      declaracionCorta(){
        if( this.puestos.findIndex(x => x == this.puesto) == -1) {
          if(this.puesto == 'admin') return true;
          else return false;}
        else return true;
    }
  },
  data: function () {
    return {
      titulo: this.$route.name,
      enviando: false,
      puestos: [  'AUDITOR', 
                  'AUTORIDAD PATRIMONIAL',
                  'COORDINADOR',
                  'DELEGADO',
                  'DIRECTOR',
                  'JEFATURA',
                  'JEFATURA A',
                  'JEFE DE GABINETE',
                  'JUEZ CALIFICADOR',
                  'JUEZ MUNICIPAL',
                  'REGIDOR',
                  'SECRETARIO',
                  'SECRETARIO PARTICULAR',
                  'SINDICO',
                  'SUB DIRECTOR',
                  'TESORERO',
                  'POLICIA',
                  'POLICIA DE LINEA',
                  'POLICIA PRIMERO',
                  'POLICIA SEGUNDO',
                  'POLICIA TERCERO'
                ]
    }
  },

  methods: {
      //modificaTipo(){
      async  modificaTipo () {

            const {value: tipo } = await swal({
                title: '',
                text: 'Seleccione el tipo de declaración:',
                input: 'select',
                allowOutsideClick: false,
                inputOptions: {
                    'INICIAL': 'INICIAL',
                    'MODIFICACIÓN': 'MODIFICACIÓN',
                    'CONCLUSIÓN': 'CONCLUSIÓN'
                },
                inputValue: this.declaracion.tipo,
                showCancelButton: true,
                confirmButtonText: 'Modificar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        resolve();
                    })
                }
            });
            if( tipo ){
                if( tipo !== this.declaracion.tipo ){

                    this.enviando = true;
                    axios.put(this.httpURL+'/declaraciones/V2/'+this.$route.params.id+'/tipo',
                            {tipo},
                            {headers: {token:this.sessionToken}})
                        .then(res => {
                            swal.close();
                            //console.log(res);
                            this.enviando = false;
                            this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                                text: res.data.mensaje });
                            this.declaracion.tipo = tipo;
                        })
                        .catch(error => {
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: 'No se pudo guardar la sección.' });
                            this.enviando = false;
                        });
                }
            }
      },
      async concluirDeclaracion(){
        const {value: concluir } = await swal({
            title: '¿Está seguro?',
            text: 'Una vez concluida la declaración, ésta no podrá ser modificada',
            type: 'warning',
            confirmButtonText: 'Concluir',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
        });
        if( concluir ){

            this.enviando = true;
            axios.put(this.httpURL + "/declaraciones/V2/" + this.$route.params.id + "/concluir",
                  {},
                  {headers: {token:this.sessionToken}})
                  .then(res => {
                    swal.close();
                    //console.log(res);
                    this.enviando = false;
                    this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
                    this.declaracion.conclusion = new Date();
                    this.declaracion.status = 'Concluida';
                    this.declaracion.consecutivo = res.data.consecutivo;
                  })
                  .catch(error => {
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo concluir la declaración.' });
                    this.enviando = false;
                  });
        }
      },
      regresar(){
          this.$router.go(-1);
      },
      verSeccion(sec){
        //console.log(sec);
          this.$emit('verSeccion',  sec, this.declaracion.status);
      },
      imprimeRecibo(){

          this.enviando = true;

            //console.log('Se solicita la declaración');
            axios({
                url: this.httpURL+'/declaraciones/V2/'+this.$route.params.id+'/imprimeConstancia',
                method: 'POST',
                responseType: 'blob', // important
                data: {},
                headers:{token:this.sessionToken}
                })
                .then(response => {
                    swal.close();
                    let blob = new Blob([response.data], { type: 'application/pdf' }),
                    url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = 'Constancia de conclusión.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    this.enviando = false;

                    })
                .catch(error => {
                    //console.log(error);
                    this.enviando = false;
                    swal.close();
                    if(error.response){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: error.response.data.mensaje });
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                                text: 'No se pudo establecer una conexión al servidor.' });
                    }
                });

//         var doc = new jsPDF({
//             orientation: 'portrait'
//         })
//         //var img = base64Img.base64Sync('../../../public/img/brand/small_landscape.png');
//         var imgData = this.logoHorizontal;
//         var consecutivo = this.declaracion.consecutivo;
//         var folio = '/2018';
//         if( consecutivo < 10 ) folio = '000'+consecutivo+folio;
//         else if( consecutivo < 100 ) folio = '00'+consecutivo+folio;
//         else if( consecutivo < 1000 ) folio = '0'+consecutivo+folio;
//         else folio = ''+consecutivo;
//         doc.setFontSize(12).text('CONSTANCIA DE RECEPCIÓN DE DECLARACIÓN PATRIMONIAL', 20, 20);
//         //doc.setFontSize(10).text('Registro: '+folio, 140, 35);
//         doc.addImage(imgData,'PNG',14,28,60,20,'Logo','NONE',0);
//         doc.line(75,28,75,48);
//         let x = 78;
//         let y = 33;
//         doc.setFontSize(10).text('CONTRALORÍA', x, y); y+= 6;
//         doc.text('DEL MUNICIPIO DE', x, y); y+= 6;
//         doc.text('EL SALTO JALISCO', x, y);

//         //doc.setFontSize(10).text('RFC: '+this.generales.rfc, 140, 43);
//         let fecha = date.format(new Date(this.declaracion.conclusion),'D de MMMM de YYYY');
//         //let fecha = '15 de noviembre de 2018';
//         //doc.setFontSize(11).text(fecha, 25, 60);

//         doc.roundedRect(20, 70, 80, 20, 2, 2);
//         let texto = doc.splitTextToSize('C. '+this.generales.nombre+' '+this.generales.paterno+' '+this.generales.materno,80);
//         //doc.setFontSize(10).text(texto, 27, 77);

//         doc.setFontSize(10).text('Presente.', 27, 88);

//         doc.roundedRect(110, 70, 80, 20, 2, 2);
//         doc.setFontSize(10).text('Declaración Patrimonial y de Intereses', 122, 77);
//         //doc.setFontSize(10).text(this.declaracion.tipo, 145, 85);

//         texto = doc.splitTextToSize(`POR ACUERDO DEL DIRECTOR GENERAL DE RESPONSABILIDADES Y SITUACIÓN PATRIMONIAL DE ESTA SECRETARÍA, ACUSAMOS RECIBO DE SU DECLARACIÓN PRESENTADA EN ESTA FECHA, PARA INCORPORARLA A SU EXPEDIENTE.`,220);
//         doc.setFontSize(8).text(texto, 25, 100);
//         texto = doc.splitTextToSize('Este acuse de recibo será válido cuando tenga el sello y la firma del responsable del centro de recepción autorizado por esta Secretaría',80);
//         doc.text(texto,25,125);

//         doc.setFontSize(10).text('Atentamente.', 140, 115);
//         doc.line(115,130,190,130);
//         doc.setFontSize(10).text('Nombre y firma del receptor', 130, 135);

// // ===============================================================================

//         doc.setFontSize(12).text('CONSTANCIA DE RECEPCIÓN DE DECLARACIÓN PATRIMONIAL', 20, 160);
//         //doc.setFontSize(10).text('Registro: '+folio, 140, 175);
//         doc.addImage(imgData,'PNG',14,168,60,20,'Logo','NONE',0);
//         doc.line(75,168,75,188);
//         x = 78;
//         y = 173;
//         doc.setFontSize(10).text('CONTRALORÍA', x, y); y+= 6;
//         doc.text('DEL MUNICIPIO DE', x, y); y+= 6;
//         doc.text('EL SALTO JALISCO', x, y);

//         //doc.setFontSize(10).text('RFC: '+this.generales.rfc, 140, 183);
//         fecha = date.format(new Date(this.declaracion.conclusion),'D de MMMM de YYYY');
//         //fecha = '15 de noviembre de 2018';
//         //doc.setFontSize(11).text(fecha, 25, 200);

//         doc.roundedRect(20, 210, 80, 20, 2, 2);
//         texto = doc.splitTextToSize('C. '+this.generales.nombre+' '+this.generales.paterno+' '+this.generales.materno,80);
//         //doc.setFontSize(10).text(texto, 27, 217);

//         doc.setFontSize(10).text('Presente.', 27, 228);

//         doc.roundedRect(110, 210, 80, 20, 2, 2);
//         doc.setFontSize(10).text('Declaración Patrimonial y de Intereses', 122, 217);
//         //doc.setFontSize(10).text(this.declaracion.tipo, 145, 225);

//         texto = doc.splitTextToSize(`POR ACUERDO DEL DIRECTOR GENERAL DE RESPONSABILIDADES Y SITUACIÓN PATRIMONIAL DE ESTA SECRETARÍA, ACUSAMOS RECIBO DE SU DECLARACIÓN PRESENTADA EN ESTA FECHA, PARA INCORPORARLA A SU EXPEDIENTE.`,220);
//         doc.setFontSize(8).text(texto, 25, 240);
//         texto = doc.splitTextToSize('Este acuse de recibo será válido cuando tenga el sello y la firma del responsable del centro de recepción autorizado por esta Secretaría',80);
//         doc.text(texto,25,265);

//         doc.setFontSize(10).text('Atentamente.', 140, 255);
//         doc.line(115,270,190,270);
//         doc.setFontSize(10).text('Nombre y firma del receptor', 130, 275);
//         doc.save('comprobante_declaracion.pdf');
      },

      // ==============================================================================

        // imprimeDeclaracion(){
            // swal('Sección en construcción.');
            // this.enviando = true;
            // axios.get(this.httpURL+'/declaraciones/'+this.$route.params.id+'/imprimeDeclaracion',
            //     {headers:{token:this.sessionToken},responseType: 'blob'})
            //     .then(response => {
            //         const url = window.URL.createObjectURL(new Blob([response.data]));
            //         const link = document.createElement('a');
            //         link.href = url;
            //         link.setAttribute('download', 'declaracion_patrimonial.pdf');
            //         document.body.appendChild(link);
            //         link.click();
            //         this.enviando = false;
            //         })
            //     .catch(error => {
            //         //console.log(error);
            //         this.enviando = false;
            //         if(error.response){
            //             this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
            //                     text: error.response.data.mensaje });
            //         }else if( error.request){
            //             this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
            //                     text: 'No se pudo establecer una conexión al servidor.' });
            //         }
            //     });
        // }


        async  imprimeDeclaracion () {
            const {value: password } = await swal({
                title: 'Zona protegida',
                text: 'Ingrese su contraseña:',
                input: 'password',
                allowOutsideClick: true,
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        resolve();
                    })
                }
            });
            if( password ){

                this.enviando = true;

                //console.log('Se solicita la declaración');
                axios({
                    url: this.httpURL+'/declaraciones/V2/'+this.$route.params.id+'/imprimeDeclaracion',
                    method: 'POST',
                    responseType: 'blob', // important
                    data: {password},
                    headers:{token:this.sessionToken}
                    })
                    .then(response => {
                        swal.close();
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                        url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = url;
                        a.download = 'Declaración patrimonial.pdf';
                        a.click();
                        window.URL.revokeObjectURL(url);

                        this.enviando = false;

                        })
                    .catch(error => {
                        //console.log(error);
                        this.enviando = false;
                        swal.close();
                        if(error.response){
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                    text: error.response.data.mensaje });
                        }else if( error.request){
                            this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                                    text: 'No se pudo establecer una conexión al servidor.' });
                        }
                    });
            }

        }

  }
}
</script>